import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copy-link"
export default class extends Controller {
  static targets = ["alert"]

  copy(event) {
    const url = event.currentTarget.dataset.url || location.href
    navigator.clipboard.writeText(url)
      .then(() => {
        // アニメーションをリセットして再生
        this.alertTarget.style.display = "block";
        const alert = this.alertTarget.querySelector(".alert");
        alert.style.animation = "none";
        alert.offsetHeight; // リフロー強制
        alert.style.animation = "";
      })
      .catch((err) => {
        console.error('クリップボードへのコピーに失敗しました:', err);
      });
  }
}
